/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyMethodModel } from '../models/client-survey-method-model';
import { getSurveyMethods$Json } from '../fn/survey-method/get-survey-methods-json';
import { GetSurveyMethods$Json$Params } from '../fn/survey-method/get-survey-methods-json';
import { getSurveyMethods$Plain } from '../fn/survey-method/get-survey-methods-plain';
import { GetSurveyMethods$Plain$Params } from '../fn/survey-method/get-survey-methods-plain';

@Injectable({ providedIn: 'root' })
export class SurveyMethodService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyMethods()` */
  static readonly GetSurveyMethodsPath = '/api/SurveyMethod';

  /**
   * get all surveymethod.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyMethods$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyMethods$Plain$Response(params?: GetSurveyMethods$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyMethodModel>>> {
    return getSurveyMethods$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveymethod.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyMethods$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyMethods$Plain(params?: GetSurveyMethods$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyMethodModel>> {
    return this.getSurveyMethods$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyMethodModel>>): Array<ClientSurveyMethodModel> => r.body)
    );
  }

  /**
   * get all surveymethod.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyMethods$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyMethods$Json$Response(params?: GetSurveyMethods$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyMethodModel>>> {
    return getSurveyMethods$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveymethod.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyMethods$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyMethods$Json(params?: GetSurveyMethods$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyMethodModel>> {
    return this.getSurveyMethods$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyMethodModel>>): Array<ClientSurveyMethodModel> => r.body)
    );
  }

}
